import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a, _b, _c;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { crowdstrikeClientSecret } = formData;
  const region = [
    { label: t("crowdstrike.regions.us_1"), value: "https://api.crowdstrike.com" },
    { label: t("crowdstrike.regions.us_2"), value: "https://api.us-2.crowdstrike.com" },
    { label: t("crowdstrike.regions.eu"), value: "https://api.eu-1.crowdstrike.com" },
    { label: t("crowdstrike.regions.government"), value: "https://api.laggar.gcw.crowdstrike.com" }
  ];
  const [formValidated, setFormValidated] = useState("");
  const fieldChange = (event) => {
    if (event) {
      setFormValidated(event.target.value);
    }
    onChange(event, null);
  };
  const [CrowdStrikeValidationStatus, setCrowdStrikeValidation] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      crowdstrike_client_id: ((_a = formData == null ? void 0 : formData.crowdstrikeClientId) == null ? void 0 : _a.value) || "",
      crowdstrike_client_secret: ((_b = formData == null ? void 0 : formData.crowdstrikeClientSecret) == null ? void 0 : _b.value) || "",
      crowdstrike_base_url: ((_c = formData == null ? void 0 : formData.crowdstrikeBaseUrl) == null ? void 0 : _c.value) || ""
    },
    urlWithEventHubParams
  );
  useEffect(() => {
    setCrowdStrikeValidation(null);
    if (CrowdStrikeValidationStatus.error) {
      setFormError({
        full_message: CrowdStrikeValidationStatus.error,
        nice_message: t("crowdstrike.errors.unable_to_connect")
      });
    }
    return () => {
      setFormError(null);
    };
  }, [CrowdStrikeValidationStatus.error, setCrowdStrikeValidation, t]);
  const handleSubmit = () => {
    setCrowdStrikeValidation(ApiRoutes.INTEGRATIONS.CrowdStrike.CHECK_CREDENTIALS);
  };
  const isFormValid = formValidation.isFormValid(
    ["crowdstrikeName", "crowdstrikeClientId", "crowdstrikeClientSecret", "crowdstrikeBaseUrl"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      loading: CrowdStrikeValidationStatus.loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "crowdstrikeName",
        type: "text",
        fieldData: formData.crowdstrikeName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: crowdstrikeClientSecret == null ? void 0 : crowdstrikeClientSecret.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "crowdstrikeClientId",
        type: "text",
        fieldData: formData.crowdstrikeClientId,
        onChange,
        label: t("crowdstrike.fields.client_id"),
        help: t("crowdstrike.fields.client_id_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "crowdstrikeClientSecret",
        type: "password",
        onChange,
        fieldData: formData.crowdstrikeClientSecret,
        help: t("crowdstrike.fields.client_secret_help"),
        label: t("crowdstrike.fields.client_secret"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "crowdstrikeBaseUrl",
        onChange: (e) => fieldChange(e),
        fieldData: formData.crowdstrikeBaseUrl,
        help: t("crowdstrike.fields.user_region_help"),
        required: true,
        label: t("crowdstrike.fields.user_region")
      },
      renderOptions(region, t("crowdstrike.fields.choose_region"), false)
    ),
    /* @__PURE__ */ React.createElement("p", null, formValidated && t("crowdstrike.fields.cloud_base_url", { url: formValidated }))
  );
};
export default StepAuthorize;
